export const cartMockData = {
  rows: [
    {
      id: 1,
      partNumber: 'BRUCE-WHEY-2321G',
      qty: 1,
      price: 226,
      total: 226,
      note: '',
    },
    {
      id: 2,
      partNumber: 'OPTIMUM-NUTRITION-500G',
      qty: 1,
      price: 226,
      total: 226,
      note: '',
    },
    {
      id: 3,
      partNumber: 'BRUCEWHEY',
      qty: 1,
      price: 226,
      total: 226,
      note: '',
    },
    {
      id: 4,
      partNumber: 'GOLD-STANDARD-1000G',
      qty: 1,
      price: 226,
      total: 226,
      note: '',
    },
    {
      id: 5,
      partNumber: 'STEROIDI',
      qty: 1,
      price: 552,
      total: 552,
      note: '',
    },
    {
      id: 6,
      partNumber: 'WHITE MONSTER',
      qty: 1,
      price: 226,
      total: 226,
      note: '',
    },
    {
      id: 7,
      partNumber: 'KUPIS',
      qty: 1,
      price: 226,
      total: 226,
      note: '',
    },
    {
      id: 8,
      partNumber: 'KRE-ALKALYN',
      qty: 1,
      price: 226,
      total: 226,
      note: '',
    },
    {
      id: 9,
      partNumber: 'XM-A2A3-0404D',
      qty: 1,
      price: 226,
      total: 226,
      note: '',
    },
    {
      id: 10,
      partNumber: 'XM-A2A3-0404D',
      qty: 1,
      price: 226,
      total: 226,
      note: '',
    },
    {
      id: 11,
      partNumber: 'XM-A2A3-0404D',
      qty: 1,
      price: 226,
      total: 226,
      note: '',
    },
    {
      id: 12,
      partNumber: 'XM-A2A3-0404D',
      qty: 1,
      price: 226,
      total: 226,
      note: '',
    },
    {
      id: 13,
      partNumber: 'XM-A2A3-0404D',
      qty: 1,
      price: 226,
      total: 226,
      note: '',
    },
    {
      id: 14,
      partNumber: 'BRUCE-WHEY-500G',
      qty: 1,
      price: 226,
      total: 226,
      note: '',
    },
    {
      id: 15,
      partNumber: 'XM-A2A3-0404D',
      qty: 1,
      price: 226,
      total: 226,
      note: '',
    },
    {
      id: 16,
      partNumber: 'XM-A2A3-0404D',
      qty: 1,
      price: 226,
      total: 226,
      note: '',
    },
    {
      id: 17,
      partNumber: 'XM-A2A3-0404D',
      qty: 1,
      price: 226,
      total: 226,
      note: '',
    },
    {
      id: 18,
      partNumber: 'XM-A2A3-0404D',
      qty: 1,
      price: 226,
      total: 226,
      note: '',
    },
    {
      id: 19,
      partNumber: 'XM-A2A3-0404D',
      qty: 1,
      price: 226,
      total: 226,
      note: '',
    },
  ],
  data: [
    {
      id: 1,
      partNumber: 'XM-A113-0404D',
      qty: 2,
      each: 96,
      total: 192,
      note: 'Something something',
      mode: 'xm-part',
    },
    {
      id: 2,
      partNumber: 'BruceWHy',
      qty: 2,
      each: 96,
      total: 192,
      note: '',
      mode: 'xm-22',
    },
    {
      id: 3,
      partNumber: 'Niggerinho',
      qty: 2,
      each: 96,
      total: 192,
      note: '',
      mode: 'xm-33',
    },
    {
      id: 4,
      partNumber: 'Niggerinho',
      qty: 2,
      each: 96,
      total: 192,
      note: '',
      mode: 'xm-33',
    },
    {
      id: 5,
      partNumber: 'Niggerinho',
      qty: 2,
      each: 96,
      total: 192,
      note: '',
      mode: 'xm-33',
    },
  ],
  header: {
    ID: 'id',
    'Part Number': 'partNumber',
    QTY: 'qty',
    Each: 'each',
    Total: 'total',
    Note: 'note',
  },
  total: ['Estimated (USD)', 192, ''],
  totalPrice: ['Total', 226, ''],
};

export const defaultHeaders = {
  ID: 'id',
  'Part Number': 'partNumber',
  QTY: 'qty',
  Each: 'each',
  Total: 'total',
  Note: 'note',
};
